module.exports = [{"type":"title","text":"2024-10-24"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位Websocket服務：新增‘模擬盤服務’"},{"type":"html","text":"新增逐倉保證金變動歷史接口：/openApi/swap/v1/positionMargin/history"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-10-24.json
// module id = Aw6+
// module chunks = 3